import ctaMan from "assets/images/psp/inlineCTA.jpg";
import illustrationSearch from "assets/images/psp/illustration-search.svg";
import GeorgeRansom from "assets/images/psp/review-george.png";
import AnnAlarcon from "assets/images/psp/review-ann.png";
import SMurphy from "assets/images/psp/review-murphy.png";
import ATVStorageOptionsImags from "assets/images/psp/ATV-storage-options.webp";
import ATVStorageImage from "assets/images/psp/atv-storage.webp";
import ATVMaintenanceImage from "assets/images/psp/atv-maintenance.webp";
import HeaderBackgroundDesktop from "assets/images/psp/hero/atv-hero.webp";
import HeaderBackgroundMobile from "assets/images/psp/hero/atv-header-mobile.webp";
import HeaderBackgroundTablet from "assets/images/psp/hero/atv-header-tablet.webp";
import { storageCategories } from "pages/PSPPage/utils/getPSPLinks";

const faqs = [
	{
		question: "What size storage unit do I need for my ATV?",
		answer: "Most ATVs fit comfortably in 10x10 or 10x12 storage units, though larger sport and utility models may require 10x15 or 10x20 spaces. Measure your ATV including any attachments like plows or cargo boxes, and add 3-4 feet on all sides for maneuvering room.\n\nIf you plan to store gear, maintenance supplies, or a small trailer alongside your four wheeler storage box needs, consider larger units. Many facilities offer size upgrade options, so you can start smaller and expand if needed.\n\nRemember that ceiling height is important too – most facilities offer 8-10 foot ceilings which accommodate ATVs with accessories or lifted suspensions."
	},
	{
		question: "How should I prepare my ATV for long-term storage?",
		answer: "Proper ATV preparation prevents costly damage during storage periods. Start by thoroughly cleaning your ATV to remove dirt and salt that can cause corrosion.\n\nChange the oil and filter, as old oil contains contaminants that can damage engine components.\n\nAdd fuel stabilizer to a full tank to prevent fuel system problems, or completely drain the fuel system for very long-term storage.\n\nRemove the battery and store it in a warm, dry place with a maintenance charger, or connect it to a storage unit power outlet with a battery tender.\n\nCheck and adjust tire pressure to prevent flat spots, and consider placing the ATV on blocks for extended storage periods."
	},
	{
		question: "Can you store an ATV in a regular storage unit safely?",
		answer: "Yes, ATVs can be safely stored in regular storage units provided the facility allows vehicles and the unit has adequate ventilation.\n\nMost reputable storage facilities welcome ATVs as long as they're properly prepared and don't contain excess fuel.\n\nLook for units with concrete floors, adequate drainage, and good air circulation.\n\nAvoid storing ATVs with full fuel tanks in enclosed spaces, and ensure any fuel stabilizer is properly added.\n\nSome facilities specialize in vehicle storage and offer enhanced features like power outlets, wash stations, and improved security specifically designed for recreational vehicles like ATVs and motorcycles."
	},
	{
		question:
			"What's the difference between indoor and outdoor ATV storage options?",
		answer: "Indoor ATV storage provides complete protection from weather, UV damage, and theft, while outdoor options typically offer less security and weather protection at lower costs.\n\nIndoor storage prevents rust, fading, and weather-related damage that can significantly impact your ATV's value and performance.\n\nCovered outdoor storage offers some weather protection but still exposes your ATV to temperature fluctuations, humidity, and potential security risks.\n\nFor valuable or frequently used ATVs, indoor storage in climate-controlled facilities provides the best protection.\n\nBudget-conscious riders might consider outdoor covered storage for older ATVs or in mild climates, but factor in potential repair costs when making this decision."
	},
	{
		question:
			"How much does ATV storage typically cost compared to building an ATV garage?",
		answer: "ATV storage costs vary significantly by location and amenities, typically ranging from $75-300 monthly depending on unit size, climate control, and security features.\n\nCompare this to building an ATV garage, which averages $15,000-30,000 for a basic structure and can exceed $50,000 for climate-controlled buildings with concrete floors and proper drainage.\n\nStorage becomes cost-effective within 4-8 years for most riders, especially when considering that you avoid property taxes, maintenance, and utility costs associated with building ownership.\n\nAdditionally, storage facilities offer immediate availability, professional security, and the flexibility to change locations as your needs evolve, advantages that permanent structures can't provide."
	}
];

const relatedContentCards = [
	{
		category: "Recreational Storage",
		url: "https://www.storage.com/blog/use-self-storage-to-store-an-atv/",
		date: "May 14, 2025",
		image: ATVStorageImage,
		content:
			"Ultimate Guide to Storing Your ATV: Protecting Your Investment"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/diy-atv-storage-maintenance-checklist/",
		date: "July 31, 2025",
		image: ATVMaintenanceImage,
		content:
			"ATV Maintenance Checklist: How to Prep and Protect Your Ride in Storage"
	},
	{
		category: "Self Storage",
		url: "https://www.storage.com/blog/cost-of-car-storage/",
		date: "September 8, 2025",
		image: "https://www.storage.com/blog/wp-content/uploads/2024/09/outdoorparking-jpg.webp",
		content:
			"How Much Does Vehicle Storage Cost? Comprehensive Guide with Price Comparisons"
	}
];

const pspLinksContent = {
	title: "More Ways to Store",
	image: illustrationSearch,
	storageTypes: storageCategories.atv
};

const reviewsContent = {
	title: "Storage.com has a 4.4 out of 5 star rating on",
	testimonials: [
		{
			body: "It was easy to find a location I needed, and once I sent my request, the gal called me that evening and was super friendly. I've been stressed about finding a place to store my car between visits, and this experience made it so easy, and now I can relax!",
			author: "Marcia Pierce-rasmussen",
			title: "Super easy and relaxing experience!",
			imageSrc: AnnAlarcon
		},
		{
			body: "Very helpful. I needed a storage space for my car that had to be a drive-up and climate-controlled, and 10x20. Efficient searching and found exactly what I was looking for, and held it for me.",
			author: "Blaine Dyson",
			title: "Very helpful",
			imageSrc: GeorgeRansom
		},
		{
			body: "This was a great place to look for local storage for my vehicle, which was a sports car for the summer. They were able to find me the closest and cheapest storage, which is not easy. They also provide terms and costs, so it was no surprise when I signed up.",
			author: "James Lee",
			title: "Excellent Place to Look for Vehicle Storage",
			imageSrc: SMurphy
		}
	]
};

const atvHerodescription = `
Maybe your ATV is a vehicle for experiencing joy in your personal life, or maybe it’s an integral part of your job out on the farm or trails. Either way, your ATV is an investment of time, and deserves to be treated as such.\n\n
Don't let weather damage, theft, or [cramped garage space](https://www.storage.com/blog/garage-vs-storage-unit-5-benefits-of-self-storage/) put your investment at risk. Professional storage for ATV units provides the secure, climate-controlled environment your four-wheeler needs to stay in peak condition between rides and through off-seasons.\n\n
Storage.com connects you with the best ATV storage facilities nationwide, so you can store with confidence and ride with peace of mind.
`;

export const PSPATVContent = {
	type: "ATV",
	sections: [
		{
			title: "ATV hero",
			noPadding: true,
			modules: [
				{
					type: "hero-section",
					props: {
						title: "Find the Top ATV Storage Units",
						description: atvHerodescription,
						searchPlaceholder: "Search by city, state, or zip...",
						buttonText: "Find ATV Storage",
						heroImages: {
							desktop: HeaderBackgroundDesktop,
							tablet: HeaderBackgroundTablet,
							mobile: HeaderBackgroundMobile
						},
						heroAltText: "ATV Storage Hero Image"
					}
				}
			]
		},
		{
			title: "ATV Storage Content",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "The Real Cost of Poor ATV Storage Choices",
						background: "white",
						content: [
							{
								id: "1",
								value: "Every ATV owner faces the same storage challenges: Your garage is packed with other vehicles and equipment, outdoor ATV storage exposes your ride to weather damage and theft, and HOA restrictions limit home storage options."
							},
							{
								id: "2",
								value: "Meanwhile, improper storage leads to battery drain, fuel system problems, tire damage, and costly repairs that could have been prevented."
							},
							{
								id: "3",
								value: "Storage units, as an ATV storage solution, solve these problems affordably. Professional ATV storage facilities provide secure, accessible space that protects your investment while freeing up valuable home storage areas."
							},
							{
								id: "4",
								value: "Instead of risking thousands in weather damage or dealing with cluttered garages, you get peace of mind at a fraction of the cost of repairs."
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "ATV Storage Size Comparison",
			noPadding: true,
			modules: [
				{
					type: "size-comparison",
					props: {
						title: "ATV Storage Unit Sizes",
						description:
							"ATV storage sizes vary greatly depending on the number of ATVs you need to store, and the gear you want to store with them. We've put together a quick guide on the most commonly available ATV storage units below:",
						background: "light-blue",
						postModuleDescription:
							"**Pricing varies by location, amenities, and seasonal demand. Additional fees may apply for power outlets, wash stations, or premium access.*",
						sizes: [
							{
								id: "10x10",
								label: "10x10",
								title: "10' Wide x 10' Long",
								description:
									"* Indoor ATV storage unit or outdoor unit with drive up access\n* Best for single ATVs, basic protection, and seasonal storage\n* $75-$150/month, depending on location and amenities"
							},
							{
								id: "10x15",
								label: "10x15",
								title: "10' Wide x 15' Long",
								description:
									"* Single ATV storage with basic gear and tools\n* Pairs well with drive up access and climate control\n* $100-$175/month, depending on location and amenities"
							},
							{
								id: "10x20",
								label: "10x20",
								title: "10' Wide x 20' Long",
								description:
									"* Stores 1-2 ATVs and gear\n* Look for drive up access for easy loading\n* Climate control comes at a premium but offers advanced protection"
							},
							{
								id: "10x25",
								label: "10x25",
								title: "10' Wide x 25' Long",
								description:
									"* Store multiple ATVs and gear\n* Great for outdoor businesses or families with multiple vehicles\n* Higher monthly costs but advanced protection and amenities available"
							}
						]
					}
				}
			]
		},
		{
			title: "ATV Storage Content",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "How to Store an ATV: Professional vs. Home Storage",
						background: "blue",
						content: [
							{
								id: "1",
								value: 'Many riders wonder "can you store an atv in a storage unit" – the answer is yes, and it\'s often the best option.'
							},
							{
								id: "2",
								value: "Professional ATV storage units are specifically designed to accommodate four-wheelers, with appropriate ceiling heights, door widths, and floor surfaces that can handle the weight and potential fluid leaks."
							},
							{
								id: "3",
								value: "**Professional ATV storage advantages:**\n\n* [Secure, gated facilities with surveillance systems](https://www.storage.com/blog/self-storage-security-features/)\n* Climate control prevents condensation and corrosion\n* Power outlets available for battery maintenance\n* Drive-up access for easy loading and unloading\n* No HOA restrictions or neighbor complaints"
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "ATV Storage Ideas",
			noPadding: true,
			modules: [
				{
					type: "video-content",
					props: {
						title: "ATV Storage Ideas That Actually Work",
						description:
							"Different storage needs require different solutions. Here's how various ATV owners benefit from professional storage.",
						mediaType: "image",
						mediaUrl: ATVStorageOptionsImags,
						videoTitle: ""
					}
				}
			]
		},
		{
			title: "ATV Storage Content 3",
			noPadding: true,
			modules: [
				{
					type: "content-section",
					props: {
						title: "What Makes ATV Storage Different from Regular Storage",
						background: "light-blue",
						listType: "single",
						content: [
							{
								id: "1",
								value: "Unlike general storage units, facilities specializing in ATV storage understand the unique needs of powersports vehicles:"
							},
							{
								id: "2",
								value: "**Appropriate Access:** Wide doors and drive-up access designed for vehicle entry"
							},
							{
								id: "3",
								value: "**Floor Drainage:** Concrete floors with proper drainage to handle cleaning and minor leaks"
							},
							{
								id: "4",
								value: "**Ventilation:** Air circulation systems to prevent moisture buildup and fuel vapor accumulation"
							},
							{
								id: "5",
								value: "**Security Features:** Enhanced security recognizing the theft risk of recreational vehicles"
							},
							{
								id: "6",
								value: "**Power Options:** Electrical outlets for battery maintenance and equipment charging"
							},
							{
								id: "7",
								value: "**Wash Stations:** On-site cleaning facilities for post-ride maintenance"
							}
						],
						isColumnWise: false
					}
				}
			]
		},
		{
			title: "ATV Storage CTA",
			noPadding: true,
			modules: [
				{
					type: "inline-cta",
					props: {
						storageType: "ATV",
						subheading: "Make a free reservation in minutes!",
						searchPlaceholder: "Search by city, state, or zip...",
						searchButtonText: "Find Storage",
						image: ctaMan,
						imageAltText: "Find ATV storage",
						background: "white"
					}
				}
			]
		},
		{
			title: "Customer Reviews",
			noPadding: true,
			modules: [
				{
					type: "reviews",
					props: reviewsContent
				}
			]
		},
		{
			title: "ATV Storage FAQs",
			noPadding: true,
			modules: [
				{
					type: "faq",
					props: {
						title: "ATV Storage FAQs",
						faqs
					}
				}
			]
		},
		{
			title: "ATV Storage Related Content",
			noPadding: true,
			modules: [
				{
					type: "related-content",
					props: {
						heading: "Learn More About ATV Storage",
						unitCards: relatedContentCards,
						background: "light-blue"
					}
				}
			]
		},
		{
			title: "Links to Other PSPs",
			noPadding: true,
			modules: [
				{
					type: "psp-links",
					props: {
						storageGridContent: pspLinksContent,
						background: "white"
					}
				}
			]
		},
		{
			title: "Storage Near You",
			noPadding: true,
			modules: [
				{
					type: "nearby-cities",
					props: {
						storageType: "atv",
						background: "light-blue"
					}
				}
			]
		}
	]
};

export default PSPATVContent;
